/**
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 14:10:32 GMT
 */

export const snackbarPaddingLeft = "16px";
export const snackbarPaddingRight = "8px";
export const snackbarBackgroundColor = "var(--color-background-base, #ffffff)";
export const snackbarBorderRadius = "12px";
export const snackbarTextMarginTop = "16px";
export const snackbarTextMarginRight = "8px";
export const snackbarTextColor = "var(--color-text-active, rgba(9, 11, 22, 0.94))";
export const snackbarTextFontSize = "15px";
export const snackbarTextFontWeight = 400;
export const snackbarTextFontLineHeight = "18px";
export const snackbarTextFontLetterSpacing = "0.2px";
export const snackbarElasticMinWidth = "344px";
export const snackbarElasticMaxWidth = "660px";
export const snackbarElasticTextMarginBottom = "16px";
export const snackbarFixedWidth = "344px";
export const snackbarFixedPaddingBottom = "8px";
export const snackbarFixedTextMarginBottom = "8px";